import {
    IconButton,
    Button,
} from '@material-ui/core';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import {
    faChevronUp, faChevronDown,
} from '@fortawesome/pro-light-svg-icons';
import { Table } from 'rsuite';
import { EmployeeBiddingStatus } from '../../../../Enums';
import './EmployeeSelectionsTable.scss';

const { Cell } = Table;

/**
 * @typedef {Object} ExpandCellProps
 * @property {BidProfileManagement.EmployeeSelectionsTableRowData} rowData
 * @property {number[]} expandedRowKeys
 * @property {Function} onChange
 * @property {Function} onEmployeeChoicesSelected
 * @property {Function} onBehalfSelected
 * @property {boolean} canViewEmployeeChoices
 * @property {boolean} isScheduled
 * @property {boolean} isBidOnBehalfAllowed
 * @property {boolean} isBidOnBehalfDisabled
 * @property {boolean} isEditBidOnBehalfAllowed
 * @property {boolean} isEditBidOnBehalfDisabled
 * @property {boolean} hasOnlyViewAccess
 * @property {any} t
 *
 * @param { ExpandCellProps & import('rsuite').CellProps } input
 */
const ExpandCell = ({
    rowData,
    expandedRowKeys,
    onChange,
    onEmployeeChoicesSelected,
    onBehalfSelected,
    canViewEmployeeChoices,
    isScheduled,
    isBidOnBehalfAllowed,
    isBidOnBehalfDisabled,
    isEditBidOnBehalfAllowed,
    isEditBidOnBehalfDisabled,
    hasOnlyViewAccess,
    t,
    ...props
}) => (
    <Cell {...props}>
        <div style={{ display: 'flex' }}>
            {rowData.hasAwardedShiftline ? (
                <IconButton
                    size="small"
                    onClick={() => {
                        onChange(rowData);
                    }}
                >
                    <FontAwesomeIcon icon={expandedRowKeys.some((key) => key === rowData.employeeId) ? faChevronUp : faChevronDown} />
                </IconButton>
            )
                : <></>}
            <div
                className="est-tablerow-action-button-container"
            >
                {
                    (rowData.status === EmployeeBiddingStatus.Unsubmitted && isBidOnBehalfAllowed)
                        && !rowData.isLocked
                        && !hasOnlyViewAccess
                        && (
                            <Button
                                onClick={() => onBehalfSelected(rowData)}
                                className="est-tablerow-action-button"
                                disabled={!isBidOnBehalfAllowed || isBidOnBehalfDisabled}
                            >
                                {t('onBehalf')}
                            </Button>
                        )
                }
                {
                    (rowData.status !== EmployeeBiddingStatus.Unsubmitted && isEditBidOnBehalfAllowed)
                        && !rowData.isLocked
                        && !hasOnlyViewAccess
                        && (
                            <Button
                                onClick={() => onBehalfSelected(rowData)}
                                className="est-tablerow-action-button"
                                disabled={!isEditBidOnBehalfAllowed || isEditBidOnBehalfDisabled}
                            >
                                {t('editBid')}
                            </Button>
                        )
                }
                {
                    !isScheduled && (
                        <Button
                            onClick={() => onEmployeeChoicesSelected(rowData.employeeId)}
                            className="est-tablerow-action-button"
                            disabled={!canViewEmployeeChoices}
                        >
                            {t('employeeChoices')}
                        </Button>
                    )
                }
            </div>
        </div>
    </Cell>
);

export default ExpandCell;
